var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: _vm.form.id ? "修改" : "新增",
        visible: _vm.dialogShow,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "80px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "标题", prop: "main_heading" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入标题" },
                model: {
                  value: _vm.form.main_heading,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "main_heading", $$v)
                  },
                  expression: "form.main_heading"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "简介", prop: "sub_heading" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入简介" },
                model: {
                  value: _vm.form.sub_heading,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "sub_heading", $$v)
                  },
                  expression: "form.sub_heading"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "链接文字", prop: "link_text" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入链接文字" },
                model: {
                  value: _vm.form.link_text,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "link_text", $$v)
                  },
                  expression: "form.link_text"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "跳转链接", prop: "link" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入跳转链接" },
                model: {
                  value: _vm.form.link,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "link", $$v)
                  },
                  expression: "form.link"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "语言", prop: "language" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.language,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "language", $$v)
                    },
                    expression: "form.language"
                  }
                },
                _vm._l(_vm.language, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "state" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.state,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "state", $$v)
                    },
                    expression: "form.state"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 2, border: "" } }, [
                    _vm._v("启用")
                  ]),
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("禁用")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: { label: "海报", prop: "poster" }
            },
            [
              _c("uploadImage", {
                attrs: { value: _vm.picfileList },
                on: { input: _vm.imgChange }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: { label: "简介详情", prop: "synopsis" }
            },
            [
              _c("Editor", {
                model: {
                  value: _vm.form.synopsis,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "synopsis", $$v)
                  },
                  expression: "form.synopsis"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogShow = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: {
                click: function($event) {
                  return _vm.clearData(true)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitData()
                }
              }
            },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }